import { NotificationManager } from 'react-notifications';
import database from '../../system/model/firebase/firebase';
// eslint-disable-next-line import/no-cycle
import { getColumn } from './vacanciesActions';

export const commentsTypes = {
  CHANGED_STATE: 'comments/CHANGED_STATE',
};

export const starTypes = {
  POST_STAR: 'star/POST_STAR',
  NOT_STAR: 'star/NOT_STAR',
};

export const MultiselectTypes = {
  POST_CANDIDATE: 'MULTI/POST_CANDIDATE',
};

export const backendTypes = {
  Email_Format: 'backend/Email_Format',
  VACANCY: 'backend/VACANCY',
  Load: 'backend/Load',
  GET_DATA: 'backend/GET_DATA',
  GET_DATA_Update: 'backend/GET_DATA_Update',
  SaveCandidate: 'backend/vacancy/SaveCandidate',
  ADD_USER_SAVE: 'database/ADD_USER_SAVE',
  UPDATE_USER_COLUMN: 'vacancy/UPDATE_USER_COLUMN',
  UPDATE_USER_DATA: 'vacancy/UPDATE_USER_DATA',
  UPDATE_USER: 'vacancy/UPDATE_USER',
  POST_COMENTS: 'vacancy/POST_COMENTS',
  SELEC_CANDIDATE: 'vacancy/SELEC_CANDIDATE',
  Drag_Candidate_Organic: 'vacancy/Drag_Candidate_Organic',
  Drag_Candidate: 'vacancy/Drag_Candidate',
  UPDATE_NAME_COLUMN: 'vacancy/UPDATE_NAME_COLUMN',
  Column_CHECK_Candidate: 'vacancy/Column_CHECK_Candidate',
  getActivity: 'vacancy/getActivity',
};

export const Post_Multi_Candidate = (data = []) => ({
  type: MultiselectTypes.POST_CANDIDATE,
  payload: data,
});

export const changedState = (payload) => ({
  type: commentsTypes.CHANGED_STATE,
  payload: payload.Comments,
});

export const checkStar = (payload) => {
  return (dispatch, getState) => {
    // dispatch(getPersonalActivity(payload.docID))
    if (payload.stars) {
      const id = getState().auth.uid;
      let bool = false;
      payload.stars.items = Object.values(payload.stars.items).map((e) => {
        if (id == e.userID) {
          bool = true;
          const temp = {
            star: e.star,
            history: payload.stars.items,
            promedio: payload.stars.promedio,
          };
          dispatch({
            type: starTypes.POST_STAR,
            payload: temp,
          });
        }
        return e;
      });
      if (!bool) {
        const temp = {
          history: payload.stars.items,
          promedio: payload.stars.promedio,
        };
        dispatch({
          type: starTypes.NOT_STAR,
          payload: temp,
        });
      }
    } else {
      const temp = {
        history: [],
        promedio: 0,
      };
      dispatch({
        type: starTypes.NOT_STAR,
        payload: temp,
      });
    }
  };
};

export const selectedCandidate = (payload, idColumn) => ({
  type: backendTypes.SELEC_CANDIDATE,
  payload: {
    ...payload,
    idColumn,
  },
});

export const getData = ({ uid, id }) => {
  return async (dispatch, getState) => {
    const {platform} = getState();
    dispatch({
      type: backendTypes.Load,
      load: true,
    });
    const connection = await database
      .collection(`${platform.platformName}/data/companies`)
      .doc(uid)
      .collection('jobs')
      .doc(id)
      .collection('applicants')
      .get();

    const parsedFetch = [];
    connection.docs.forEach((doc) => {
      const preparsed = doc.data();
      preparsed.docID = doc.id;
      parsedFetch.push(preparsed);
    });
    // console.log(parsedFetch)

    dispatch({
      candidates: parsedFetch,
      candidates_Store: parsedFetch,
      type: backendTypes.GET_DATA,
    });

    // dispatch(getColumn({uid, id}));

    if (parsedFetch.length === 0) {
      NotificationManager.info(`Todavía no hay candidatos que mostrar`, '', 3000);
    } else {
      NotificationManager.success(`Obtuvimos ${parsedFetch.length} candidatos`, '', 3000);
    }

    await dispatch(getColumn({ uid, id, parsedFetch }));
    // const connection2 = await database.collection(`companies/${uid}/jobs`).doc(id).get();
    // Acá se debe poner una redirección si esta vaci
    // dispatch({
    //     title: connection2.data().jobTitle,
    //     volumenVacancy: connection2.data().volumenVacancy,
    //     totalCandidates: connection2.data().totalCandidates,
    //     type: vacancyTypes.GET_TITLE_VACANCY
    // })
  };
};

export const postComment = (payload) => {
  return (dispatch, getState) => {
    const { idAplicant, uid, comments, Aplicants, id } = payload;
    const {platform} = getState();
    database
      .collection(`${platform.platformName}/data/companies`)
      .doc(uid)
      .collection('jobs')
      .doc(id)
      .collection('applicants')
      .doc(idAplicant)
      .update({
        Comments: comments,
      })
      .then((e) => {
        // dispatch(getPersonalActivity(idAplicant))
        dispatch({
          type: commentsTypes.CHANGED_STATE,
          payload: Aplicants.Comments,
        });
      });
  };
};

export const updateComment = (payload) => {
  return (dispatch, getState) => {
    const { idAplicant, uid, comments, Aplicants, id } = payload;
    const {platform} = getState();
    database
      .collection(`${platform.platformName}/data/companies`)
      .doc(uid)
      .collection('jobs')
      .doc(id)
      .collection('applicants')
      .doc(idAplicant)
      .update({
        Comments: comments,
      })
      .then((e) => {
        // dispatch(getPersonalActivity(idAplicant))
        changedState(Aplicants);
      });
  };
};

export const postStar = (payload) => {
  return (dispatch, getState) => {
    const candidates_Store = getState().backend?.vacancy?.candidates_Store;
    const {platform} = getState();
    const { Star, star, doc, edited, aplicant, email, userName, userID, timestamp, vacancyOwner } = payload;

    const sendable = {
      edited,
      email,
      timestamp,
      userID,
      userName,
      star,
    };

    let history = [];
    let promedio = 0;
    const {uid} = getState().auth;
    if (Star !== false) {
      history = Star.items;
      history.map((e) => {
        promedio += e.star;
      });
      promedio += star;
      promedio /= history.length + 1;
    } else {
      promedio += star;
    }

    promedio = promedio.toFixed(1);
    history.push(sendable);

    database
      .collection(`${platform.platformName}/data/companies`)
      .doc(uid)
      .collection('jobs')
      .doc(vacancyOwner)
      .collection('applicants')
      .doc(aplicant)
      .update({
        stars: {
          items: history,
          promedio,
        },
      })
      .then((e) => {
        const temp_User = candidates_Store.find((e) => e.docID == aplicant);
        if (temp_User.applyID) {
          database
            .collection(`${platform.platformName}/data/companies`)
            .doc(uid)
            .collection('applicantsBase')
            .doc(temp_User.applyID)
            .update({
              stars: {
                promedio,
              },
            });
        }
        const temp = {
          star,
          history,
          promedio,
        };
        // dispatch(getPersonalActivity(aplicant))
        dispatch({
          type: starTypes.POST_STAR,
          payload: temp,
        });
      });
  };
};
export const GET_DATA_Update = (value) => ({
  type: backendTypes.GET_DATA_Update,
  candidates_Store: value,
});
export const updateStar = (payload) => {
  return (dispatch, getState) => {
    const candidates_Store = getState().backend?.vacancy?.candidates_Store;
    const {platform} = getState();
    const { userID, doc, aplicant, star, promedio, history, idColumn, docID } = payload;
    const _index = 0;

    let column = [];
    // if (idColumn !== 'canidates') {
    //
    //
    //
    //     // column[idColumn].map((e, index) => {
    //     //     if (e.docID === docID) {
    //     //         _index = index
    //     //         e.stars.promedio = promedio
    //     //     }
    //     // })
    // } else {
    //     column = getState().backend?.vacancy?.candidates_Store;
    //     column.find(e =>{
    //         if(e.docID == aplicant || e.idUser == aplicant){
    //             e.stars.promedio = promedio
    //         }
    //     })
    //     // column.map((e, index) => {
    //     //     if (e.docID === docID) {
    //     //         _index = index
    //     //         e.stars.promedio = promedio
    //     //     }
    //     // })
    // }
    column = getState().backend?.vacancy?.candidates_Store.slice();
    column.find((e) => {
      if (e.docID == aplicant || e.idUser == aplicant) {
        e.stars.promedio = promedio;
      }
    });
    database
      .collection(`${platform.platformName}/data/companies`)
      .doc(userID)
      .collection('jobs')
      .doc(doc)
      .collection('applicants')
      .doc(aplicant)
      .update({
        stars: {
          items: history,
          promedio,
        },
      })
      .then((e) => {
        const temp_User = candidates_Store.find((e) => e.docID == aplicant);
        if (temp_User.applyID) {
          database
            .collection(`${platform.platformName}/data/companies`)
            .doc(userID)
            .collection('applicantsBase')
            .doc(temp_User.applyID)
            .update({
              stars: {
                promedio,
              },
            });
        }

        const temp = {
          star,
          history,
          promedio,
        };
        // dispatch(getPersonalActivity(aplicant))
        dispatch({
          type: starTypes.POST_STAR,
          payload: temp,
        });
        dispatch(GET_DATA_Update(column));
      });
  };
};
